<template>
    <div class="page-container">
        <keep-alive>
            <router-view v-if="$route.meta.keepAlive" />
        </keep-alive>
        <router-view v-if="!$route.meta.keepAlive" />
    </div>
</template>

<script>
// import { Icon } from 'vhtml-ui';

// const req = require.context('./assets/icons', false, /[^.]+\.svg$/);
// Icon.addSprites(req);

export default {
  components: {},
  data() {
    return {};
  },
  computed: {},

  created() { },

  methods: {},
};
</script>
